import * as React from 'react';
import Box from '@mui/material/Box';

import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import TablePagination from "@mui/material/TablePagination";
import {useEffect, useState} from "react";
import {getCurrentPageEntries, setCurrentPageEntries} from "./VerificationUtils";
import {Diagnoses} from "../../components/diagnoses";

export default function VerificationTablePagination({pageEntries, count, onRowsPerPageChange, onPageChange}) {
    // console.log('VerificationTablePagination: ', pageEntries, count, onRowsPerPageChange, onPageChange, disabled)

    return (
        <TablePagination
            sx={{mr:10,width:'100%'}}
            component="div"
            showFirstButton
            showLastButton
            count={count}
            page={pageEntries.pageNumber}
            onPageChange={onPageChange}
            rowsPerPage={pageEntries.rowsPerPage}
            onRowsPerPageChange={onRowsPerPageChange}
            labelRowsPerPage={"Строк на странице"}
        />
    );
}
